/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_VarietalInputs */

const en_field_varietal = /** @type {(inputs: Field_VarietalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Varietal / Blend`)
};

const es_field_varietal = /** @type {(inputs: Field_VarietalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Varietal / Mezcla`)
};

const fr_field_varietal = /** @type {(inputs: Field_VarietalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cépage / Assemblage`)
};

const de_field_varietal = /** @type {(inputs: Field_VarietalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rebsorte / Cuvée`)
};

const ja_field_varietal = /** @type {(inputs: Field_VarietalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`品種 / ブレンド`)
};

const zh_field_varietal = /** @type {(inputs: Field_VarietalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`葡萄品种 / 混合`)
};

const ar_field_varietal = /** @type {(inputs: Field_VarietalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`صنف العنب / المزيج`)
};

const id_field_varietal = /** @type {(inputs: Field_VarietalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Varietas / Campuran`)
};

const it_field_varietal = /** @type {(inputs: Field_VarietalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vitigno / Uvaggio`)
};

const ru_field_varietal = /** @type {(inputs: Field_VarietalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сорт винограда / Бленд`)
};

const pt_field_varietal = /** @type {(inputs: Field_VarietalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Casta / Blend`)
};

const ko_field_varietal = /** @type {(inputs: Field_VarietalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`품종 / 블렌드`)
};

/**
* | output |
* | --- |
* | "Varietal / Blend" |
*
* @param {Field_VarietalInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const field_varietal = /** @type {((inputs?: Field_VarietalInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_VarietalInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_varietal(inputs)
	if (locale === "es") return es_field_varietal(inputs)
	if (locale === "fr") return fr_field_varietal(inputs)
	if (locale === "de") return de_field_varietal(inputs)
	if (locale === "ja") return ja_field_varietal(inputs)
	if (locale === "zh") return zh_field_varietal(inputs)
	if (locale === "ar") return ar_field_varietal(inputs)
	if (locale === "id") return id_field_varietal(inputs)
	if (locale === "it") return it_field_varietal(inputs)
	if (locale === "ru") return ru_field_varietal(inputs)
	if (locale === "pt") return pt_field_varietal(inputs)
	return ko_field_varietal(inputs)
});